import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { GoalService } from '../../../services/goal.service';
import { subject } from '@casl/ability';
import { DirectionService } from '../../../services/direction.service';
import { Goal } from '../../../interfaces/models/goal.model';
import { ConfirmPopup, ConfirmPopupModule } from 'primeng/confirmpopup';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../../services/auth.service';
import { authUser } from '../../../interfaces';
import { CustomAblePipe } from '../../../pipes/able.pipe';
import { ButtonModule } from 'primeng/button';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-goals',
  standalone: true,
  imports: [TranslateModule, RouterModule, CommonModule, CustomAblePipe, ButtonModule, ConfirmPopupModule],
  templateUrl: './goals.component.html',
  styleUrl: './goals.component.scss',
  providers: [ConfirmationService],
})
export class GoalsComponent implements OnDestroy, OnInit {
  @ViewChild(ConfirmPopup) confirmPopup!: ConfirmPopup;
  @ViewChild('goalForm') goalForm!: FormGroup;
  @Output() ShowUpdateGoalModalEvent = new EventEmitter<number>();
  @Output() AddGoalModalEvent = new EventEmitter<void>();
  @Output() onIndicatorsClick = new EventEmitter<number>();
  @Output() onProjectsClick = new EventEmitter<number>();
  @Input() isModal: boolean = false;


  unsubscribe$ = new Subject<void>();
  constructor(private toastr: ToastrService,
    private confirmationService: ConfirmationService,
    private goalService: GoalService,
    private directionService: DirectionService,
    private authService: AuthService
  ) {
  }
  isVisibleGoalModal = false;
  selectedGoal!: any;
  selectedUpdateGoalId = 0;
  user!: authUser;
  isGoalFormSubmitted = false;
  @Output() onViewGoalDetails = new EventEmitter<any>();
  ngOnInit(): void {
    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
    })
    this.authService.authBufferSub$.pipe(takeUntil(this.unsubscribe$)).subscribe((user) => {
      this.user = user as authUser;
    })
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  @Input() selectedStrategyId = 0
  @Input() isViewOnly = true
  _goals!: any[];
  @Input() set goals(model: any[]) {

    this._goals = model;
  }
  dir!: 'rtl' | 'ltr';
  activeMenuId: number | null = null;

  get goals() {
    return this._goals;
  }

  toggleMenu(event: Event, goalId: number) {
    event.stopPropagation();
    this.activeMenuId = this.activeMenuId === goalId ? null : goalId;
  }

  closeMenu() {
    this.activeMenuId = null;
  }

  closeAllMenus() {
    this.activeMenuId = null;
  }

  confirmGoalDelete(event: Event, id: number) {
    const target = event.target as HTMLElement;
    this.confirmationService.confirm({
      target: target,
      message: this.dir == 'rtl' ? 'هل تريد تأكيد المسح؟' : 'Do you want to confirm the deletion?',
      accept: () => {
        this.goalService.deleteGoal(+this.selectedStrategyId, id).pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
          this.goals = this.goals?.filter(goal => goal.id != id);
          this.toastr.success(this.dir == 'rtl' ? 'تمت المسح ' : 'The goal has been deleted successfully.', this.dir == 'rtl' ? 'عملية ناجحة' : 'Success');
        })
      },
      reject: () => {
        this.toastr.info(this.dir == 'rtl' ? "تم الالغاء" : "The deletion has been canceled.", this.dir == 'rtl' ? 'الغاء' : 'Canceled');
      }
    });
  }

  accept() {
    this.confirmPopup.accept();
  }

  reject() {
    this.confirmPopup.reject();
  }

  showUpdateGoalModal(goalId: number) {
    this.ShowUpdateGoalModalEvent.emit(goalId);
  }
  showGoalModal() {
    this.AddGoalModalEvent.emit();
  }
  
  showGoalDetailsModal(goal: any) {
    this.onViewGoalDetails.emit(goal);
  }

}
